<div class="customer-basic-info">
  <div>
    <h1>{{ customer?.name }}</h1>
    <div>
      <div>{{ 'label.ID' | translate }}:</div>
      <div>{{ customer?.customerId }}</div>
    </div>
    <div>
      <div>{{ 'label.RegistrationDate' | translate }}:</div>
      <div>{{ customer?.registrationDate | date : dateFormat }}</div>
    </div>
    <div>
      <div>{{ 'label.ApprovalDate' | translate }}:</div>
      <div>{{ customer?.approvalDate | date : dateFormat }}</div>
    </div>
    <div>
      <div>{{ 'label.Status' | translate }}:</div>
      <div>{{ customer?.statusName }}</div>
    </div>
    <div>
      <div>{{ 'label.Type' | translate }}:</div>
      <div>{{ customer?.customerTypeName }}</div>
    </div>
    <div>
      <div>{{ 'label.FeedType' | translate }}:</div>
      <div>{{ customer?.customerFeedTypeName }}</div>
    </div>
    <div>
      <div>{{ 'label.Portfolio' | translate }}:</div>
      <div>{{ customer?.customerPortfolio?.name }}</div>
    </div>
    <div>
      <div>{{ 'label.AccountManager' | translate }}:</div>
      <div>
        {{
          customer?.customerPortfolio?.currentAccountManager?.admin?.fullName
        }}
      </div>
    </div>
  </div>
  <div>
    <div class="link">
      <a href="">{{ 'label.CustomerAnnouncements' | translate }}</a>
    </div>
    <div class="link">
      <p-button
        type="button"
        class="ui-button-secondary"
        (click)="onCustomerArchive()"
        *ngIf="customer?.statusId == CustomerStatusEnum.Active"
        [disabled]="!hasCustomerArchivePermission"
        label="{{ 'label.Archive' | translate }}"
      ></p-button>
    </div>
  </div>
</div>
